/** @format */
import qs from 'qs';

import { Market } from '@toucan/client/global/market';

import { ModelSearchResultsType } from '../constants';
import { hasOneProductInResult } from '../helpers';
import {
    ModelSearchResultsFetchOptions,
    ModelSearchResultsSearchParams,
    Query,
    SelectedFilters,
} from '../types';
import { fetchModelSearchResults, getSKUForResult } from './requests';

function alphabeticallySortFilterQuery(
    selectedFilters: SelectedFilters
): SelectedFilters {
    return Object.fromEntries(
        // eslint-disable-next-line id-length -- Legacy code: do not use as an example.
        Object.entries(selectedFilters).sort((a, b) => {
            if (a[0] < b[0]) return -1;
            if (a[0] > b[0]) return 1;
            return 0;
        })
    );
}

export const getSortedFilterQueryString = (
    selectedFilters: SelectedFilters
) => {
    const sortedFilterQuery = alphabeticallySortFilterQuery(selectedFilters);

    return qs.stringify(sortedFilterQuery, { arrayFormat: 'comma' });
};

function getSortQuery(
    searchParams: ModelSearchResultsSearchParams,
    type?: ModelSearchResultsType
) {
    const sort = searchParams.sort;

    if (!Object.keys(sort).length) {
        if (type === ModelSearchResultsType.SEARCH) {
            return {};
        }

        return {
            ['productPrice']: 'DESC',
        };
    }

    const [facet, direction] = Object.entries(sort)[0];

    if (facet === 'relevance') {
        return {};
    }

    return { [facet]: direction };
}

export async function getModelSearchResults(
    baseQuery: Partial<Query>,
    searchParams: ModelSearchResultsSearchParams,
    start: number,
    rows: number,
    activeMarket: Market,
    {
        type,
        shouldUseSemanticSearch = false,
    }: ModelSearchResultsFetchOptions = {}
) {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const { outOfStock, selectedFilters } = searchParams;

    const sort = getSortQuery(searchParams, type);

    const modelSearchResults = await fetchModelSearchResults(
        baseQuery,
        selectedFilters,
        sort,
        start,
        rows,
        activeMarket,
        outOfStock,
        shouldUseSemanticSearch
    );

    if (searchParams.showAll) {
        return modelSearchResults;
    }

    if (hasOneProductInResult(modelSearchResults.results)) {
        const modelId = modelSearchResults?.results?.[0]?.modelId?.values?.[0];

        if (modelId) {
            modelSearchResults.results[0].productSku = await getSKUForResult(
                baseQuery,
                activeMarket,
                modelId,
                outOfStock
            );
        }
    }

    return modelSearchResults;
}
